import type { AxiosResponse } from 'axios';

export enum SeoPageBlockType {
  header = 'header',
  paragraph = 'paragraph',
  list = 'list',
}

type SeoPageHeading = {
  id: string;
  type: SeoPageBlockType.header;
  data: {
    level: number;
    text: string;
    slug: string;
  };
};

type ListData = {
  style: string;
  items: Array<
    ListData & {
      content: string;
    }
  >;
};

type SeoPageList = {
  id: string;
  type: SeoPageBlockType.list;
  data: ListData;
};

type SeoPageParagraph = {
  id: string;
  type: SeoPageBlockType.paragraph;
  data: {
    text: string;
  };
};
export type SeoPageContent = {
  language: string;
  title: string;
  seo_description: string;
  seo_title: string;
  body: {
    blocks: Array<SeoPageHeading | SeoPageList | SeoPageParagraph>;
  };
};

export type SeoPageQueryData = {
  contents: Array<SeoPageContent>;
  created_on: string;
  updated_on: string;
  slug: string;
};

export type SeoPageQueryResponse = AxiosResponse<SeoPageQueryData>;

export type SeoReturnType = {
  getPage: (slug: string) => Promise<SeoPageQueryResponse>;
};
